import { createContextValue } from '@texas/utils/contextState';
import { useCallback, useEffect } from 'react';
import { MessageClass, Handler, MessageBus } from './messageBus';
import { useStableCallback } from '@texas/hooks/useStableCallback';

export function usePublisher() {
  const messageBus = useMessageBus();

  const publish = useCallback(
    <T>(message: T) => {
      messageBus.publish(message);
    },
    [messageBus],
  );

  return { publish };
}

export function useSubscriber<T>(
  Message: MessageClass<T>,
  handler: Handler<T>,
) {
  const messageBus = useMessageBus();
  const stableHandler = useStableCallback(handler);

  useEffect(
    () => messageBus.subscribe(Message, stableHandler),
    [Message, stableHandler, messageBus],
  );
}

export const [MessageBusProvider, useMessageBus] =
  createContextValue<MessageBus>();
